import {
  useMemo } from "react";
  import { useTranslation } from "react-i18next";
  import {
  CarOutlined,
  EnvironmentOutlined,
  DollarOutlined,
  RiseOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";
import "../style.css";

const iconByIndex: Record<number, JSX.Element> = {
  0: <CarOutlined />,
  1: <EnvironmentOutlined />,
  2: <DollarOutlined />,
  3: <CheckCircleOutlined />,
};

const BenefitsSection = () => {
  const { t } = useTranslation("tms");

  const items = useMemo(() => {
    const raw = t("benefits.items", { returnObjects: true }) as unknown;
    if (!Array.isArray(raw)) return [];
    return raw as Array<{ title: string; desc: string }>;
  }, [t]);

  return (
    <section className="dev-tms-section dev-tms-benefits-section">
      <div className="dev-tms-section-inner">
        <h2 className="dev-section-h2 dev-tms-section-h2">
          <span className="dev-tms-section-h2-icon dev-tms-section-h2-icon--amber" aria-hidden>
            <RiseOutlined />
          </span>
          <span>{t("benefits.title")}</span>
        </h2>

        <div className="dev-tms-benefits-grid">
          {items.slice(0, 5).map((item, idx) => (
            <div key={idx} className="dev-tms-benefit-card">
              <div className="dev-tms-benefit-left">
                <span className="dev-tms-benefit-number">{String(idx + 1).padStart(2, "0")}</span>
                <span className="dev-tms-benefit-icon">{iconByIndex[idx] ?? null}</span>
              </div>
              <div className="dev-tms-benefit-body">
                <div className="dev-tms-benefit-title">{item.title}</div>
                <div className="dev-tms-benefit-desc">{item.desc}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
